import React from 'react'

import * as passwordValidators from '../../shared/passwordValidators'

import * as styles from './PasswordRequirements.m.css'

type Props = {
  password: string
  confirmPassword: string
}

const PasswordRequirements: React.FC<Props> = (props): React.ReactElement => {
  const { password, confirmPassword } = props

  if (password.length === 0 && confirmPassword.length === 0) {
    return <></>
  }

  const passwordSubValidatorChecks = passwordValidators.subvalidators(password)
  const passwordValidStyle = (test: boolean) =>
    test ? styles.validPass : styles.invalidPass
  const hasEightCharacters = passwordValidStyle(
    passwordSubValidatorChecks.hasEightCharacters,
  )
  const hasDigit = passwordValidStyle(passwordSubValidatorChecks.hasDigit)
  const hasLowerCase = passwordValidStyle(
    passwordSubValidatorChecks.hasLowerCase,
  )
  const hasSpecialCharacter = passwordValidStyle(
    passwordSubValidatorChecks.hasSpecialCharacter,
  )
  const passwordsMatch = passwordValidStyle(password === confirmPassword)

  return (
    <div>
      <div className={hasEightCharacters}>At least 8 Characters</div>
      <div className={hasDigit}>At least 1 digit</div>
      <div className={hasLowerCase}>At least one letter</div>
      <div className={hasSpecialCharacter}>At least one special character</div>
      <div className={passwordsMatch}>Passwords Match</div>
    </div>
  )
}

export default PasswordRequirements
